import { Button, Grid } from '@material-ui/core'
import React, { useEffect, useState } from 'react'

import { useHomeStore } from 'context/HomeStore'
import { useAuthStore } from 'context/AuthStore'
import { getFirstDayOfMonth } from 'lib/utils'
import { FilterList } from '@material-ui/icons'
import BottomDialog from 'asterX-UI/BottomDialog/BottomDialog'
import { useStyles } from './filter.styles'
import { FilterMobile } from './components/FilterMobile'
import { FilterDesktop } from './components/FilterDesktop'

export const Filter = ({ page = 'home' }) => {
  const classes = useStyles()
  const { authStore, authStoreFunc } = useAuthStore()
  const { homeStore, homeStoreFunc } = useHomeStore()
  const [mobileFilter, setMobileFilter] = useState(false)
  const combinedEventResultList = []
  const uniqueCodes = new Set()

  homeStore?.statuses?.list?.forEach(item => {
    item?.eventResultList?.forEach(eventResult => {
      if (!uniqueCodes.has(eventResult.code)) {
        uniqueCodes.add(eventResult.code)
        combinedEventResultList.push(eventResult)
      }
    })
  })

  const handleSearch = () => {
    homeStoreFunc.handleSearch()
    if (authStore.isMobile) {
      setMobileFilter(false)
    }
  }

  const handleClear = () => {
    homeStoreFunc.handleClearFilter()
  }

  const branchesWithCode = homeStore?.branches?.map(branch => ({
    code: branch
  }))

  useEffect(() => {
    if (page === 'completed') {
      homeStoreFunc.handleFilterDateChange(getFirstDayOfMonth(), 'completedByFrom')
    }
  }, [])

  return (
    <Grid container spacing={4} className={classes.filter}>
      {authStore.isMobile && (
        <Button fullWidth variant="outlined" onClick={() => setMobileFilter(true)}>
          {<FilterList />} Фильтр
        </Button>
      )}

      {!authStore.isMobile && (
        <FilterDesktop
          page={page}
          homeStore={homeStore}
          homeStoreFunc={homeStoreFunc}
          authStoreFunc={authStoreFunc}
          combinedEventResultList={combinedEventResultList}
          branchesWithCode={branchesWithCode}
          onClear={handleClear}
          onSearch={handleSearch}
        />
      )}

      <BottomDialog title="Фильтр" open={mobileFilter} onClose={() => setMobileFilter(false)}>
        <FilterMobile
          page={page}
          homeStore={homeStore}
          homeStoreFunc={homeStoreFunc}
          authStoreFunc={authStoreFunc}
          combinedEventResultList={combinedEventResultList}
          branchesWithCode={branchesWithCode}
          onClear={handleClear}
          onSearch={handleSearch}
        />
      </BottomDialog>
    </Grid>
  )
}
